{
    "fileHashes": {
        "cs": "4d7c7a205e796a2026d6e1e14e44ea20e85efbd9484be14edf33d2072b9b03fa",
        "de": "4879ca4233ddac0d323c7a9f13ad9d6a4f5033342c6e501511f7fe41c02d5285",
        "en": "1263dc4ed97b101e7d93a4f3405551c1c5908c0a6bc939d32082d300f9e829ef",
        "es": "d11d96a093b4f94bbf08dd41e3bb82d7a747f30ab39790012c295ccf2cd2558e",
        "fr": "534966d9cb4957c9f02fbcfa5d55e51a75093015b4bf82113218b1bbfa30d75b",
        "hu": "4128174b290d933cc585d5fcd5544b12b099ac292033d1b24db42fe3fc4ff00b",
        "id": "22bfe9d46f49b2e48207fecbff8f8a5e42755f57aed0d17edad73ebd3eb4589e",
        "it": "54dc9f8f12d202dbbe0f7775dce522416068d6ff8213c3793d311c4cc79c2a1b",
        "ja": "e4bc5b1440cc50d2984326a40a4ee15928b4e03bafa502e634a1be1d4553320d",
        "ko": "035e267d89ab438ddef3173acc2c148dc89e91c26b962bfb627916f4be81b947",
        "nl": "3d3cdc1aa53120cea03436b0910a7b45f7b0fcdb8d669eea756ff8c5db72416f",
        "pl": "4e63f9f7620f086a2b315d65e6fdf755ad0cd9d89b1a18272484c347fc456687",
        "pt": "9c7055617e4768a582d9da6061f6c835d85b6b58d2c3612883555533b1363940",
        "th": "9517204f9034b68bfaf5e1e3e84c9db526d89e4adfd24504a8c30aeae3d1e752",
        "tr": "c2df268cbb519b53da4b70f61f463b39f5906bbd44cb3a5ce3d10d2914c8db3d",
        "zh": "b9988f9c2cc687b93ffdc2085983f70ed9c63efc7f1a2d0a54e4a17981b4617d",
        "zh_TW": "8bcb3520249d60a2f9ff85f28a94a8198c20be2c3d7100819b9575684ce33187"
    },
    "lastUpdatedAt": "2026-10-15T07:46:22.004Z"
}
